import type { RenderNode } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';

// Нельзя рендерить <p> в <p>, а мы часто используем ~components/Typography <P> для стилизации. Span с display block - ближайшая аппроксимация
export const renderParagraphNode: RenderNode = {
	[BLOCKS.PARAGRAPH]: (_, children) => (
		<span style={{ display: 'block' }}>{children}</span>
	),
};

// Contentful не позволяет проставлять ссылкам target="_blank"
export const renderAnchorBlankNode: RenderNode = {
	[INLINES.HYPERLINK]: (node, children) => {
		const { uri, ...rest } = node.data;
		const href: string = typeof uri === 'string' ? uri : '';

		return (
			<a {...rest} target="_blank" href={href}>
				{children}
			</a>
		);
	},
};
